import { Deserializable } from '../../protocols/deserializable';

export class ChangeEmailRequest implements Deserializable {
  public newEmail: string = '';
  onDeserialize = () => {};
}
